/** Возвращает GroupId для сайта */
export const getLifeRaySiteGroupId = () => {
  if (window.Liferay){
      return window.Liferay.ThemeDisplay.getSiteGroupId();
  }
  return "38304"; //"20124";
}
